import React from 'react';

import { IBenefit } from 'shared/domain/entities';
import { Trans, useLocale } from 'shared/presentation/contexts';
import { useCurrencyFormatter } from 'shared/presentation/hooks';

import * as S from './styles';

interface IDiscountCouponContentProps {
  title?: boolean;
  benefit: IBenefit;
}

const DiscountCouponContent: React.FC<IDiscountCouponContentProps> = ({
  title = true,
  benefit,
}) => {
  const { t } = useLocale('shared');
  const formatter = useCurrencyFormatter();

  return (
    <S.Container>
      {title && (
        <h1>
          <Trans
            t={t}
            localeKey="A true friend is the one that refer <1>{{value}} in discounts</1> to you and your friends <3>Enjoy!</3>"
          >
            {'A true friend is the one that refer '}
            <strong>
              {{
                value: formatter.format(
                  benefit.recommendation.givenCoupon.value,
                ),
              }}
              {' in discounts'}
            </strong>
            {' to you and your friends '}
            <strong>Enjoy!</strong>
          </Trans>
        </h1>
      )}

      <div>
        <p>
          <Trans
            t={t}
            localeKey="As soon as three friends, that dont know Vialaser yet, register themselves, you will get an <1>{{value}} exclusive coupon</1> at your email for the purchase of any package"
          >
            {
              'As soon as three friends, that dont know Vialaser yet, register themselves, you will get an '
            }
            <strong>
              {{
                value: formatter.format(benefit.recommendation.discount.value),
              }}
              {' exclusive coupon'}
            </strong>
            {' at your email for the purchase of any package '}
          </Trans>
        </p>

        <p>
          {t('Coupon valid only for purchases above {{value}}', {
            value: formatter.format(benefit.minimumBudgetValue),
          })}
        </p>
      </div>
    </S.Container>
  );
};

export default DiscountCouponContent;
